import { render, staticRenderFns } from "./PFReclaimList.vue?vue&type=template&id=20c96f1b&scoped=true"
import script from "./PFReclaimList.vue?vue&type=script&lang=js"
export * from "./PFReclaimList.vue?vue&type=script&lang=js"
import style0 from "./PFReclaimList.vue?vue&type=style&index=0&id=20c96f1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c96f1b",
  null
  
)

export default component.exports